<template>
  <div class="news-student-detail">
        <!-- <newsHeader :page="'优秀学员'"></newsHeader> -->
         <breadCrumb></breadCrumb>
        <!-- <el-breadcrumb separator="/" class="bread-crumb main">
            <el-breadcrumb-item :to="{ path: '/news' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/news/student' }">优秀学员</el-breadcrumb-item>
            <el-breadcrumb-item>学员详情</el-breadcrumb-item>
        </el-breadcrumb> -->
        <div class="news-student-detail-wrapper main flex-between">
            <div class="side-navbar">
               <div class="title f20">{{info.name}}</div>
               <ul >
                   <li v-for="(li, index) in navbarList" 
                       :key="index"
                       :class="{'active':isActive===index}" 
                       @click="isActive=index">
                        <a href="javascript:;" @click="isActive=index"><i></i>{{li}}</a>
                    </li>
               </ul>
           </div>
           <div class="student-info" v-show="isActive === 0">
             <div class="basic-msg flex-layout">
                 <div>
                     <img :src="info.image" alt="">
                 </div>
                 <table>
                    <tr>
                        <th>姓名</th>
                        <td>{{info.name}}</td>
                    </tr>
                    <tr>
                        <th>职称</th>
                        <td>{{info.title}}</td>
                    </tr>
                     <tr>
                        <th>{{isType}}学校</th>
                        <td>银川市实验小学阅海第二校区</td>
                    </tr>
                     <tr>
                        <th>{{isType}}学科</th>
                        <td>语文</td>
                    </tr>
                     <tr>
                        <th>{{isType}}年级</th>
                        <td>三年级</td>
                    </tr>
                 </table>
             </div>
             <p class="describe">
                 {{info.instruction}}
             </p>
           </div>
           <div class="student-deeds" v-show="isActive === 1">
               <p>{{info.instruction}}</p>
                <div class="nothing-box" v-if="!info.instruction">
                    <img src="@/assets/news/nothing.png" alt="">
                    <p>暂无信息</p>
                </div>
            </div>   
        </div>
        <div class="footer-section">
            <footer-view></footer-view>
        </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            isActive:0,
            navbarList:['基本信息','学习事迹'],
            info:'',
        }
    },
    computed:{
        isType:function(){
            if(this.info.category === 1) {
                return '任教'
            } else if(this.info.category === 2) {
                return '所属'
            }
            
        }
    },
     methods: {
         async GetTeaInfo(){
            let params ={
               id:this.$route.params.id, 
            }
            let resData = await Api.News.getTeaInfo(params)
            console.log(resData.data)
            this.info = resData.data;
            // this.studentList = resData.rows
      }
    },
    mounted() {
        this.GetTeaInfo();
        // console.log(this.$route.params.id);
    }   
}
</script>

<style lang="less">
    @import "../less/news_studetn_detail.less";
</style>